import {reservationTypes} from "../types/reservationTypes";

const initState = {
    upcomingReservationsIsLoading: true,
    upcomingReservations: [],
    upcomingReservationsNotFound: null,
    pastReservationsIsLoading: true,
    pastReservations: [],
    pastReservationsNotFound: null,
    fetchMorePastReservation: false,
    noMorePastReservations: false,
    upcomingReservationDetails: null,
    upcomingReservationDetailsIsLoading: true,
    authPopUpStatus: false,
    activationPopUpStatus: false,
};
const reservationReducer = (state = initState, action) => {
    switch (action.type) {
        case reservationTypes.CHANGE_AUTH_POP_UP_STATUS :
            state = {
                ...state,
                authPopUpStatus: action.payload,
            };
            break;
        case reservationTypes.CHANGE_ACTIVATION_POP_UP_STATUS :
            state = {
                ...state,
                activationPopUpStatus: action.payload,
            };
            break;
        case reservationTypes.GET_UPCOMING_RESERVATIONS :
            state = {
                ...state,
                upcomingReservations: action.payload,
                upcomingReservationsIsLoading: false
            };
            break;
            case reservationTypes.UPCOMING_RESERVATIONS_NOT_FOUND :
            state = {
                ...state,
                upcomingReservationsNotFound: action.payload,
            };
            break;
        case reservationTypes.CLEAR_UPCOMING_RESERVATIONS :
            state = {
                ...state,
                upcomingReservationsIsLoading: true,
                upcomingReservations: [],
            };
            break;
        case reservationTypes.GET_PAST_RESERVATIONS :
            state = {
                ...state,
                pastReservationsIsLoading: false,
                pastReservations: [...state.pastReservations, ...action.payload],
            };
            break;
        case reservationTypes.FETCHING_MORE_PAST_RESERVATIONS :
            state = {
                ...state,
                fetchMorePastReservation: action.payload,
            };
            break;
        case reservationTypes.CLEAR_PAST_RESERVATIONS :
            state = {
                ...state,
                pastReservationsIsLoading: true,
                pastReservations: [],
            };
            break;
        case reservationTypes.NO_MORE_PAST_RESERVATIONS :
            state = {
                ...state,
                noMorePastReservations: action.payload,
            };
     /*   case reservationTypes.PAST_RESERVATIONS_NOT_FOUND :
            state = {
                ...state,
                pastReservationsNotFound: action.payload,
            };
            break;*/

        default:
        // do nothing
    }

    return state;
};
export default reservationReducer
